import { render, staticRenderFns } from "./VideoPlayer.Chunked.vue?vue&type=template&id=0979716e&scoped=true&"
import script from "./VideoPlayer.Chunked.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.Chunked.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.Chunked.vue?vue&type=style&index=0&id=0979716e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979716e",
  null
  
)

component.options.__file = "VideoPlayer.Chunked.vue"
export default component.exports